(function () {
  const playVideo = (video) => {};

  const stopVideo = (video) => {};

  const initSection = (section) => {
    let sectionVideo = document.currentScript ? document.currentScript.parentElement : section;

    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
        }
      });
    });
  };

  document.addEventListener('shopify:section:load', function (section) {
    initSection(section.target);
  });
})();

document.addEventListener('DOMContentLoaded', () => {
  const videoPlayButtons = document.querySelectorAll('.video-section__play-button');

  function closeVideoModal(videoModal, videoModalContent) {
    if (!videoModal || !videoModalContent) return;
    videoModal.classList.add('tw-hidden');
    videoModal.classList.remove('tw-flex');
    document.body.style.overflow = ''; // Restore scrolling
    const videoElement = videoModalContent.querySelector('video');
    if (videoElement) {
      videoElement.pause();
      videoElement.currentTime = 0;
    }
  }

  function playVideo(videoElement, videoModal) {
    if (!videoElement || !videoModal) return;
    // Started by a click, so browsers allow playback with sound
    videoElement.muted = videoModal.dataset.muted === 'true';

    // Show the modal before playing, also on mobile: a video inside a hidden (display: none)
    // modal keeps playing audio but renders a black picture after pause/resume
    document.body.style.overflow = 'hidden'; // Prevent scrolling
    videoModal.classList.remove('tw-hidden');
    videoModal.classList.add('tw-flex');
    videoElement.play()?.catch(() => {});

    if (window.innerWidth <= 768) {
      // Mobile device
      if (videoElement.requestFullscreen) {
        videoElement.requestFullscreen();
      } else if (videoElement.mozRequestFullScreen) {
        // Firefox
        videoElement.mozRequestFullScreen();
      } else if (videoElement.webkitRequestFullscreen) {
        // Chrome, Safari and Opera
        videoElement.webkitRequestFullscreen();
      } else if (videoElement.msRequestFullscreen) {
        // IE/Edge
        videoElement.msRequestFullscreen();
      }
    }
  }

  videoPlayButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const sectionId = button.getAttribute('data-video-section');
      if (!sectionId) return;

      const videoModal = document.getElementById(`videoModal-${sectionId}`);
      const videoModalContent = videoModal ? videoModal.querySelector('.video-content') : null;

      if (videoModalContent) {
        const videoElement = videoModalContent.querySelector('video');
        if (videoElement) {
          videoElement.currentTime = 0; // Reset video to start
          playVideo(videoElement, videoModal);
        }
      }
    });
  });

  // Setup event listeners for all video modals
  document.querySelectorAll('.video-modal').forEach((videoModal) => {
    const closeModal = videoModal.querySelector('.video-modal-close');
    const closeModalButton = videoModal.querySelector('.close-modal-button');
    const videoModalContent = videoModal.querySelector('.video-content');
    const videoModalContainer = videoModal.classList.contains('desktop-only') ? videoModal : null;

    if (closeModal) {
      closeModal.addEventListener('click', () => closeVideoModal(videoModal, videoModalContent));
    }
    if (closeModalButton) {
      closeModalButton.addEventListener('click', () => closeVideoModal(videoModal, videoModalContent));
    }

    // Click outside to close
    if (videoModalContainer) {
      window.addEventListener('click', (event) => {
        if (event.target === videoModalContainer) {
          closeVideoModal(videoModal, videoModalContent);
        }
      });
    }
  });

  // Global Escape key listener
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      document.querySelectorAll('.video-modal').forEach((videoModal) => {
        if (!videoModal.classList.contains('tw-hidden')) {
          const videoModalContent = videoModal.querySelector('.video-content');
          closeVideoModal(videoModal, videoModalContent);
        }
      });
    }
  });

  // Fullscreen change handlers
  function handleFullscreenChange() {
    const isFullscreen =
      document.fullscreenElement ||
      document.mozFullScreenElement ||
      document.webkitFullscreenElement ||
      document.msFullscreenElement;

    if (!isFullscreen && window.innerWidth <= 768) {
      // Leaving fullscreen on mobile closes the video
      document.querySelectorAll('.video-modal').forEach((videoModal) => {
        if (!videoModal.classList.contains('tw-hidden')) {
          closeVideoModal(videoModal, videoModal.querySelector('.video-content'));
        }
      });
    }
  }

  document.addEventListener('fullscreenchange', handleFullscreenChange);
  document.addEventListener('mozfullscreenchange', handleFullscreenChange);
  document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
  document.addEventListener('msfullscreenchange', handleFullscreenChange);
});
